window._define('mediapopup', ['jquery'], function ($) { 'use strict';

    return {
        init: function () {
            //handle everything with the fancybox class
            $('.fancybox').fancybox({
                openEffect: 'none',
                closeEffect: 'none',
                padding: 0,
                aspectRatio: true,
                beforeLoad: function () {
                    this.width  = this.element.data('fancybox-width');
                    this.height = this.element.data('fancybox-height');
                },
                onLoading: function () {
                    $('#fancybox-loading')
                        .empty()
                        .html('<div><i class="icon-large icon-spinner icon-spin"></i></div>');
                },
                helpers: {
                    media: {},
                },
            });
        },
    };
});

